module.exports = __webpack_public_path__ + "img/logo.b2380ff3.png";